export default "__VITE_ASSET__NGG4J2x5__"